package core.io.dto

import core.enums.EJSBridgeActions
import kotlinx.serialization.SerialName

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 06.04.23
 * Author : mariorosshirt
 */
@kotlinx.serialization.Serializable
data class JSBridgeActionDTO<T>(
 @SerialName("action")
 val mAction: EJSBridgeActions,

 @SerialName("data")
 val mData: T? = null
)
